import type { EditorPlugin } from '../../types/aha-editor';
import MetadataOperationsHandler from './MetadataOperationsHandler';

// Metadata operations allow adding, removing, and setting properties on the editor.metadata object
const MetadataPlugin: EditorPlugin[] = [MetadataOperationsHandler];

export default MetadataPlugin;
